<template>
  <div>
    <div>
      <b-modal id="google-sign-in-modal" hide-footer title="Auth with google">
        <GoogleLoginPopup />
      </b-modal>
    </div>
    <b-card>
      <div class="lg:flex md:flex gap-4 container">
        <div class="lg:w-1/2 md:w-1/2 w-full mt-28 p-4">
          <Calendar />
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-28 md:mt-28 mt-12 p-4">
          <Date />
        </div>
      </div>
    </b-card>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Calendar from "./components/Calendar.vue";
import Date from "./components/Date.vue";
import Footer from "../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import GoogleLoginPopup from "./components/GoogleLogin2.vue";
import { mapState } from "vuex";

export default {
  components: {
    Calendar,
    Date,
    Footer,
    DownloadApp,
    GoogleLoginPopup,
  },
  data() {
    return {
      GoogleLogin: false,
    };
  },
  mounted() {
    if (this.$route.query.code) {
      window.localStorage.setItem("isGoogleSigned", true);
    } else {
      window.localStorage.setItem("isGoogleSigned", false);
    }

    let isGoogleSigned = window.localStorage.getItem("isGoogleSigned");
    // console.log("isGoogleSigned", isGoogleSigned);
    if (isGoogleSigned == "true" || this.$route.query.code) {
      // console.log("Hello", this.$route.query.code);
    } else {
      this.GoogleLogin = true;
      // this.$bvModal.show("google-sign-in-modal");
      // console.log(this.GoogleLogin, "Hello");
    }
  },
  computed: {
    ...mapState("auth", ["sessionPrice"]),
  },
};
</script>

<style>
#google-sign-in-modal {
  display: grid !important ;
  place-items: center !important;
}
</style>
